import { CombinedClientPublicCandidateActionTypes } from "../";
import { ClientPublicCandidateState } from "../clientPublicCandidateState";
import { creators } from "./clientPublicCandidateUIActionTypes";

export const useClientPublicCandidateUIActions = (
    state: ClientPublicCandidateState,
    dispatch: React.Dispatch<CombinedClientPublicCandidateActionTypes>
) => ({
    setSelectedLeadTab: (tab: string) =>
        dispatch(creators.setSelectedLeadTab(tab)),
    clearError: () => dispatch(creators.clearError()),
});

export type UIActions = ReturnType<typeof useClientPublicCandidateUIActions>;
